<template>
  <div class="main-balls-section">
    <div class="main">
      <div
        v-for="(value, propertyName) in balls"
        :class="'main-balls ' + propertyName + '-balls'"
        :key="propertyName"
      >
        <div
          v-for="ball in value"
          :class="ball.selected ? 'ticket-ball ' + ball.color + '-ball ticket-ball-choosen' : 'clickable-ball ticket-ball ball-shadow ' + ball.color + '-ball'"
          :id="'ball' + ball.id"
          :key="ball.id"
          @click="selectBall(ball)"
        >
          <div class="ticket-ball-number">{{ ball.number }}</div>
        </div>
        <div
          :class="'ticket-ball ' + propertyName + '-ball empty abh-color'"
          :data-color="propertyName"
          @click="selectColor(propertyName)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["balls"],
  data() {
    return {
      selectedBalls: []
    };
  },
  methods: {
    selectBall(ball) {  
      this.$emit('selectBall', ball);
    },
    selectColor(color) {
      this.$emit('selectColor', color);
    }
  }
};
</script>
